module.exports = __webpack_public_path__ + "static/media/overview_illustration_hz.0b2c1f61.svg";